import { minBreakpoints, primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const desktopWrapper = css`
  display: none;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: block;
    `,
  )};
`;

export const mobileWrapper = css`
  display: block;
  margin: 0;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: none;
    `,
  )};
`;

export const list = css`
  display: flex;
  justify-content: space-between;
  column-gap: ${spacing.lg}px;
  padding: ${spacing.xxl}px 0 0;
  list-style-type: none;
  border-top: 1px solid var(--neutral-black-30);
  border-bottom: 1px solid var(--neutral-black-30);

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      column-gap: ${spacing.xl}px;
    `,
  )};
`;

export const title = css`
  ${primarySemiBoldFont};
  ${responsiveText.HEADING.XS};
`;
